export class DataSourceCore {

  constructor(store, dataSources) {
    this.store = store
    this.dataSources = dataSources
    this.dataSourcesPool = {}
  }

  /**
   * Create DataSource
   *
   * @param Vue - Component instance
   * @param id - Unique identifier of dataSource
   * @returns DataSource instance
   */
  async CreateDataSource(Vue, id)  {
    if (!this.dataSources[id]) {
      return null
    }

    return this.createDataSourceModel(Vue, id, await this.dataSources[id](), this.store.getters.DataSources)
  }

  /**
   * Get from pool or create a new DataSource
   *
   * @param Vue - Component instance
   * @param id - Unique identifier of dataSource
   * @returns DataSource instance
   */
  async GetOrCreate(Vue, id)  {
    const pooledDataSource = this.getPooledDataSource(id)
    if (pooledDataSource) {
      return pooledDataSource
    }

    if (!this.dataSources[id]) {
      return null
    }

    return this.createDataSourceModel(Vue, id, await this.dataSources[id](), this.store.getters.DataSources)
  }

  /**
   * Get DataSource
   *
   * @param id - Unique identifier of dataSource
   * @returns DataSource instance
   */
  GetDataSource(id) {
    return this.getPooledDataSource(id)
  }   

  createDataSourceModel(Vue, id, dataSourceCounstructor, dataSources) {
    const dataSourceItem = dataSources.find(x => x.$ID === id)
    if (!dataSourceItem) {
      return null
    }

    const dataSourceModel = new dataSourceCounstructor.default(Vue, dataSourceItem)
    this.poolDataSource(id, dataSourceModel)

    return dataSourceModel
  }

  getPooledDataSource(id) {
    return this.dataSourcesPool[id]
  }

  poolDataSource(id, dataSourceModel) {
    this.dataSourcesPool[id] = dataSourceModel
  }
}